import { Component, OnInit , Input } from '@angular/core';
import { MigrationService } from 'src/app/services/migration.service';

@Component({
  selector: 'app-migration-transactions',
  templateUrl: './migration-transactions.component.html',
  styleUrls: ['./migration-transactions.component.css']
})
export class MigrationTransactionsComponent implements OnInit {

  redirectBaseUrl = 'https://holesky.etherscan.io/tx/';
  @Input() transactions = [];
  constructor(private migrationService: MigrationService) { }

  ngOnInit(): void {
  }

  getBaseUrl(network) {
    if (network == 'eth') {
      return 'https://holesky.etherscan.io/tx/';
    } else {
      return 'https://holesky.etherscan.io/tx/';
    }
  } 

}
